import {required} from "vuelidate/lib/validators";  
const StrKontrolIsbirlikci = {
    data() {
      return { 
        StrKontrolIsbirlikciData: { 
          TanimId:"",
          BirimIds:[], 
          Tip:"",
          Alive: true,
          Deleted: false,  
        } ,
          FormDataType:{ 
            TanimId:{FieldName:"TanimId",Field:"combobox",FieldTitle:this.$t('StrKontrolIsbirlikci.AddEdit.TanimId'),ComboDataArray:[],Disabled:"disableda"}, 
            BirimIds:{FieldName:"BirimIds",Field:"birimcombobox",FieldTitle:this.$t('StrKontrolIsbirlikci.AddEdit.BirimIds'),ComboDataArray:[]}, 
            Tip:{FieldName:"Tip",Field:"combobox",FieldTitle:this.$t('StrKontrolIsbirlikci.AddEdit.Tip'),ComboDataArray:[{ Id: "1", Value: "İşbirliği Yapılacak" },{ Id: "2", Value: "Sorumlu" }]},   
          }   
      }
    },
    validations:{ 
      FormData: { 
         TanimId: { required }, 
         BirimIds: { required },  
         Tip: { required } 
      } 
 
   }, 
   created(){  
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsGet({"Service":"StrKontrolTanim", "Page":Page}).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.TanimId.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].TamamlanmaAciklama,
        });
      }
    });
    
    this.ActionsGet({"Service":"OBirim/GetTree", "Page":Page}).then((res) => {
      let tumu = [];
      tumu.push({ id: 1, label: "Tümü", children: null });
      tumu[0].children = JSON.parse(JSON.stringify(res.Data).replaceAll("[]","null"));
      this.FormDataType.BirimIds.ComboDataArray = tumu;   
      });


  }
}
export default StrKontrolIsbirlikci